angular.module('dpw.services')

    .factory('grantTypeUtils', [function () {
        return {
            
            /**
             * Translate grant type ids into names.
             *
             * @param {Object} grantTypeConfig - "id -> name" translation rules.
             * @param {Array} grantTypeIds - grant type ids to be translated.
             * @returns {Array} Translated grant type names.
             */
            translateGrantTypeIds: function (grantTypeConfig, grantTypeIds) {
                var grantTypeNames = _.map(grantTypeIds, function (id) {
                    return _.get(grantTypeConfig, [id, 'name']);
                });

                // Consider the order of grant type ids retrieved from back-end may be different
                grantTypeNames.sort();

                return grantTypeNames;
            },

            /**
             * Check if the grant type container doesn't have any grant types.
             *
             * @param {Array} grantTypes - the grant type container to be checked.
             * @returns {Boolean} True if the grant type container doesn't have any grant types.
             */
            isGrantTypesEmpty: function (grantTypes) {
                return _.isEmpty(grantTypes);
            }
            
        };
    }])

;